import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const terminalLogout = http.delete(
  createMockEndpoint('/terminal/:id/logout'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
